import Badge from './Badge';
import { withInstall } from '../_util/type';
export default withInstall(Badge);
